import React, { Component, useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import {
  Box,
  Container,
  Divider,
  Button,
  Typography,
  Grid,
  IconButton,
} from '@material-ui/core';

import { Image } from '../../../components/image/image.component';
import { isHebrew } from '../../../App';

const useStyles = makeStyles((theme) => ({
  root: {
    overflow: 'hidden',
    width: '100%',
    height: '100%',
    borderRadius: '24px',
  },
}));

const VideoCard = (props) => {
  const classes = useStyles({ isHebrew: isHebrew() });
  const { imageURL } = props;
  const { companyImageURL, title, detail } = props;

  return (
    <Box className={classes.root} position="relative">
      <Image className="w-100 h-100" src={imageURL} />
      <Box
        zIndex={1}
        position="absolute"
        width="100%"
        height="100%"
        top={0}
        left={0}
        display="flex"
        flexDirection="column"
        justifyContent="flex-end"
        alignItems="center"
        pb={2}
      >
        <Box
          width="44px"
          height="44px"
          borderRadius="30%"
          overflow="hidden"
          mb={1}
        >
          <Image src={companyImageURL} className="image-cover" />
        </Box>
        <Typography variant="h6" color="textSecondary" align="center">
          <Box
            style={{ textShadow: '2px 2px rgba(0, 0, 0, 0.3)' }}
            fontSize="h5.fontSize"
            fontWeight="bold"
            mb={1}
          >
            {title}
          </Box>
        </Typography>
        <Typography variant="h6" align="center" color="secondary">
          <Box
            style={{ textShadow: '2px 2px rgba(0, 0, 0, 0.3)' }}
            fontSize="h5.fontSize"
            fontWeight="bold"
          >
            {detail}
          </Box>
        </Typography>
      </Box>
    </Box>
  );
};
export default VideoCard;
